import type { GameManifest } from "../contracts/game";

export type HomeSlot =
  | { kind: "game"; manifest: GameManifest }
  | { kind: "placeholder"; key: string };

export class GameRegistry {
  readonly #byId = new Map<string, GameManifest>();
  readonly #homeGames: readonly GameManifest[];

  constructor(manifests: readonly GameManifest[]) {
    for (const manifest of manifests) {
      if (!Number.isInteger(manifest.catalogOrder) || manifest.catalogOrder < 0) {
        throw new Error(`Invalid catalog order for ${manifest.id}`);
      }
      if (this.#byId.has(manifest.id)) {
        throw new Error(`Duplicate game ID: ${manifest.id}`);
      }
      this.#byId.set(manifest.id, manifest);
    }

    this.#homeGames = [...manifests]
      .filter((manifest) => manifest.status !== "hidden")
      .sort(
        (left, right) =>
          left.catalogOrder - right.catalogOrder || left.id.localeCompare(right.id),
      );
  }

  listHomeGames(): readonly GameManifest[] {
    return [...this.#homeGames];
  }

  get(id: string): GameManifest | undefined {
    return this.#byId.get(id);
  }
}

export function buildHomeSlots(
  games: readonly GameManifest[],
  totalPositions = 12,
): readonly HomeSlot[] {
  const slots: HomeSlot[] = games
    .slice(0, totalPositions)
    .map((manifest) => ({ kind: "game", manifest }));

  for (let index = slots.length; index < totalPositions; index += 1) {
    slots.push({ kind: "placeholder", key: `placeholder-${index + 1}` });
  }

  return slots;
}
